// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Button  } from 'vant';
import { Popup } from 'vant';
import { Icon } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Search } from 'vant';
import { List } from 'vant';
import { Toast } from 'vant';
import { Overlay } from 'vant';
import { Loading } from 'vant';
import { Collapse } from 'vant';
import { CollapseItem } from 'vant';
import wx from 'weixin-js-sdk';//引入
import axios from 'axios';
import xhr from './api/RqAxios'
import vshare from 'vshare'
// import { WECHAT_BROWSER } from "./utils/browser.js";
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.prototype.wx = wx;
Vue.prototype.baseUrl = 'http://project.tsinghua-auto.cn'
// require styles
import 'swiper/dist/css/swiper.css'

// if (WECHAT_BROWSER && window.location.search.includes('from_wx') === false) {
//   let url = window.location.href
//   url += (location.search ? '&' : '?') + 'from_wx=1'
//   window.location.replace(url)
// }
// 微信浏览器判断
const WECHAT_BROWSER = navigator.userAgent.toLowerCase().includes('micromessenger')
const wxQuery = '_wx_=1'
const isRepeatQuery = location.search.includes(wxQuery)
if (WECHAT_BROWSER && !isRepeatQuery) {
 const unit = (location.search && location.search !== '?') ? '&' : '?'
 location.search += unit + wxQuery  // 添加_wx_参数，该操作会刷新页面
}
Vue.prototype.$axios = axios;
Vue.prototype.$http = xhr
// Vue.prototype.HOME = 'http://xinwen.qingsongjk.com'
//http://xinwen.qingsongjk.com
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(List);
Vue.use(Loading);
Vue.use(Search);
Vue.use(Cell).use(CellGroup);
Vue.use(Overlay);
Vue.use(DropdownMenu).use(DropdownItem);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Toast);
Vue.use(vshare)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js